import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class MerchantOnboardingListItem extends Component {
    static propTypes = {
        item: PropTypes.any
    };

    renderMerchantName(merchantName) {
        return merchantName ? merchantName : 'No Merchant Name';
    }

    renderStatus(status) {
        return status ? status : 'No Status';
    }

    render() {
        const merchant = this.props.item;

        return (
            <div className="list-item">
                <div className="list-item-left">
                    <span className="merchant-onboarding-merchantName">
                        {this.renderMerchantName(merchant.legalName)}
                    </span>
                    <span className="merchant-onboarding-merchantId">
                        {merchant.merchantId}
                    </span>
                </div>
                <div className="list-item-right">
                    <span className="merchant-onboarding-status">
                        {this.renderStatus(merchant.status)}
                    </span>
                </div>
            </div>
        );
    }
}
